<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header {{msgType}}">
    <i class="search-icon " [iconName]="msgType"></i>
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{titleKey|translate}}</h4>
    <button [disabled]="false" type="button" value="Close" class="close" aria-label="Close" title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="reject()">
      <span class="icon-Close" aria-hidden="true" ></span>
    </button>
  </div>
  <div class="modal-body" [innerHtml]="messageKey | translate">

  </div>
  <div class="modal-footer">

    <div class="modal-buttons">
            <span *ngIf="showCancel">
                <breeze-button buttonText="{{cancelLabel|translate}}" id="cancel-btn" [isSecondary]="true" [isDisabled]="cancelDisable"
                               (clicked)="reject()"></breeze-button>
            </span>
      <breeze-button buttonText="{{confirmLabel|translate}}" id="ok-btn" [isPrimary]="true" [isDisabled]="okDisable"
                     (clicked)="confirm()" [isAutoFocus]="true"></breeze-button>

    </div>
  </div>
</div>

